import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { type QueryState, wrapQuery } from "../queryState";
import type { SessionOverviewVM } from "../types/session";
import type { SessionDetailVM } from "../types/execution";
import { useSubscriptionActive } from "../components/SubscriptionScope";

/**
 * useSessionOverview — wraps sessionOverview composite (PRD Section 8)
 */
export function useSessionOverview(): QueryState<SessionOverviewVM> {
  const active = useSubscriptionActive();
  const raw = useQuery(
    api.composites.sessionOverview.sessionOverview,
    active ? {} : "skip"
  );
  return wrapQuery(raw, (r) => r as SessionOverviewVM);
}

/**
 * useSessionDetail — wraps sessionDetail composite (PRD Section 8)
 */
export function useSessionDetail(
  sessionId: string
): QueryState<SessionDetailVM> {
  const active = useSubscriptionActive();
  const raw = useQuery(
    api.composites.sessionDetail.sessionDetail,
    active ? { sessionId } : "skip"
  );
  return wrapQuery(raw, (r) => r as SessionDetailVM);
}
